import { render, staticRenderFns } from "./NsPagination.vue?vue&type=template&id=430d87fe&scoped=true&"
import script from "./NsPagination.vue?vue&type=script&lang=js&"
export * from "./NsPagination.vue?vue&type=script&lang=js&"
import style0 from "./NsPagination.vue?vue&type=style&index=0&id=430d87fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430d87fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsIcon: require('/usr/app/src/components/ns/NsIcon.vue').default})
